import { useState, useEffect } from 'react';

const withPositionData = ({ node }) => {
  const [position, setPosition] = useState(null);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [node]);

  const onScroll = () => {
    if (node) {
      setPosition(node.getBoundingClientRect());
    }
  };

  return {
    position
  };
};

export default withPositionData;